@if (automatic || (!automatic && !manual)) {
  <div class="played-wrapper">
    @for (item of bets.slice(0, 2); track item; let i = $index) {
      <div class="item">
        @for (number of item.numbersChecked; track number) {
          <div class="number">{{number}}</div>
        }
        @for (number of item.extraChecked; track number) {
          <div class="number extra">{{number}}</div>
        }
        @if (i != 0 && invisibleSpace > 0) {
          <div class="number invisible"></div>
        }
        <button class="number option" (click)="randomBet(item, i)"><img src="/assets/images/icons/games/button/dice.svg"></button>
        <button class="number option" (click)="deleteBet(item, i)"><img src="/assets/images/icons/games/button/trash.svg"></button>
      </div>
    }
    @if (showAll) {
      <div>
        @for (item of bets.slice(2); track item; let i = $index) {
          <div class="item">
            @for (number of item.numbersChecked; track number) {
              <div class="number">{{number}}</div>
            }
            @for (number of item.extraChecked; track number) {
              <div class="number extra">{{number}}</div>
            }
            @if (invisibleSpace) {
              <div class="number invisible"></div>
            }
            <button class="number option" (click)="randomBet(item, i + 2)"><img src="/assets/images/icons/games/button/dice.svg"></button>
            <button class="number option" (click)="deleteBet(item, i + 2)"><img src="/assets/images/icons/games/button/trash.svg"></button>
          </div>
        }
      </div>
    }
    @if (bets.length > 2) {
      <button class="visibility-button" (click)="showAll = !showAll">{{ showAll ? 'Ver menos' : 'Ver más' }}</button>
    }
  </div>
}